import collaboration_img from "public/about-us/handshake.jpeg";
import innovation_img from "public/about-us/innovation.png";
import sustainability_img from "public/about-us/green.png";

export const PILLARS_CONSTANTS = {
  title: "Where Innovation Meets Intuition.",
  list: [
    {
      image: collaboration_img,
      title: "Collaboration: The Power of Unity ",
      content:
        "At OneMind, we believe that great innovations stem from collaboration. By working closely with our clients and leveraging diverse expertise, we create solutions that are both effective and forward-thinking. Together, we build strategies that enhance business operations and drive sustainable success. ",
    },
    {
      image: innovation_img,
      title: "Innovation: Pushing Boundaries, Defining the Future ",
      content:
        "We are passionate about driving innovation in everything we do. Our team continuously explores cutting-edge technologies and creative solutions to push the boundaries of what’s possible. By embracing new ideas and rapid adaptability, we empower businesses to stay ahead of the curve in an ever-evolving digital world. ",
    },
    {
      image: sustainability_img,
      title: "Green Data Centers by 2035: A Sustainable Cloud Future ",
      content:
        "At OneMind, we are committed to sustainability and responsible innovation. By 2035, our goal is to operate eco-friendly, energy-efficient data centers that minimize environmental impact without compromising performance. Through responsible practices and sustainable operations, we help businesses succeed while contributing to a healthier planet for future generations. ",
    },
  ],
};
